import { defineMessages } from "react-intl";

const messages = defineMessages({
  generalStoryTitle: {
    id: "components.StreamStories.generalStoryTitle",
    defaultMessage: "Recommended {type}"
  },
  authorPluralization: {
    id: "components.StreamStories.authorPluralization",
    defaultMessage: "authors"
  },
  photographerPluralization: {
    id: "components.StreamStories.photographerPluralization",
    defaultMessage: "photographers"
  },
  officePluralization: {
    id: "components.StreamStories.officePluralization",
    defaultMessage: "offices"
  },
  companyPluralization: {
    id: "components.StreamStories.companyPluralization",
    defaultMessage: "companies"
  },
  categoryPluralization: {
    id: "components.StreamStories.categoryPluralization",
    defaultMessage: "categories"
  },
  productCategoryPluralization: {
    id: "components.StreamStories.productCategoryPluralization",
    defaultMessage: "product categories"
  }
});

export default messages;
